import React from "react";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

const UserLogout = (accessToken) => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigation = useNavigate();


  const handleLogin = async () => navigation("/training");

  return (
    <Grid>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <Container maxWidth="sm">
          <Typography variant="h6" align="center" gutterBottom>
            You have been logged out successfully.
          </Typography>
          <Typography variant="body1" align="center">
            To log in again, please click the button below:
          </Typography>

          <Box display="flex" justifyContent="center" mt={2}>
              <Button
                color="primary"
                variant="contained"
                id="login-button"
                type="button"
                onClick={handleLogin}
              >
                Login
              </Button>
          </Box>
        </Container>
      </Box>
    </Grid>
  );
};

export default UserLogout;
